<template>
  <!-- Admin Panel -->
  <v-list v-if="user_role == DEFINES.USER_ROLE_SUPER_ADMIN">
    <template v-if="layout == DEFINES.LAYOUT_ADMIN">
      <v-list-tile
        class="default-class highlight"
        :color="color"
        @click="goToLink('Companies')"
      >
        <v-list-tile-action>
          <v-icon color="saSecondary"
            >$vuetify.icons.screener_back</v-icon
          >
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="saSecondary--text">{{
            $t("rms.drawer.back_to_company")
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <template v-else>
      <v-list-tile
        color="default-class highlight"
        @click="goToLink('AdminDashboard')"
      >
        <v-list-tile-action>
          <v-icon color="secondary">mdi-account-box-outline</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="secondary--text">{{
            $t("rms.drawer.go_to_admin")
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      color: "blue",
    };
  },

  computed: {
    ...mapState({
      user_role: (state) => state.user.profile.role,
      layout: (state) => state.app.app.layout,
    }),
  },

  methods: {
    goToLink: function (pageName) {
      this.$router.push({ name: pageName });
    },
  },
};
</script>
